import { render, staticRenderFns } from "./CRUDTable.vue?vue&type=template&id=f7f8ab94"
import script from "./CRUDTable.vue?vue&type=script&lang=js"
export * from "./CRUDTable.vue?vue&type=script&lang=js"
import style0 from "./CRUDTable.vue?vue&type=style&index=0&id=f7f8ab94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports